import { render, staticRenderFns } from "./DriftChat.vue?vue&type=template&id=47c62470&"
import script from "./DriftChat.vue?vue&type=script&lang=js&"
export * from "./DriftChat.vue?vue&type=script&lang=js&"
import style0 from "./DriftChat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports